// we write all api calls here

import { endpoints } from "@app/api/apis";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";


// export const BavVerifyAction: ActionFunction<BAVVerifyActionPayload> = async (
//   action,
//   _datastore,
//   {setDatastore, network, navigate, instrumentTrack, goBack, navigateToBase},
// ): Promise<any> => {
//   instrumentTrack('VERIFY_BANK_EXISTING_ACCOUNT_SELECTED')


//   console.warn("SELECTED ITEM", action.payload.selectedItem)
//   await setDatastore(action.routeId, 'continue', <ButtonProps>{
//       loading: true,
//   })

//   const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : (await SharedPropsService.getUser())
//       .linkedApplications[0].applicationId
//   const response = await network.post(
//       api.bavVerify,
//       {
//           applicationId,
//           bankAccountDetails: {
//               // @ts-ignore
//               bankAccountNumber: action.payload.selectedItem.accountNumber,
//               // @ts-ignore
//               bankIfscCode: action.payload.selectedItem.ifscCode,
//           },
//       },
//       {headers: await getAppHeader(), handleFromMF: true},
//   )

//   if (_.get(response, 'status') !== 200) {
//       // @ts-ignore
//       const ifscNum = action?.payload?.selectedItem?.ifscCode
//       const errorMessage = response?.response?.data?.message
//       const errorCode =  response?.response?.data?.voltErrorCode
//       if(errorCode === "KYC_VERIFICATION_FAILED_NAME_MISMATCH") {
//           const failureJson =  JSON.parse(response?.response?.data?.message)
//           const heading = failureJson?.nameMatchFailureDetails?.description
//           const key1 = failureJson?.nameMatchFailureDetails?.source?.description
//           const value1 = failureJson?.nameMatchFailureDetails?.source?.value
//           const key2 = failureJson?.nameMatchFailureDetails?.target?.description
//           const value2 = failureJson?.nameMatchFailureDetails?.target?.value
//           await navigate(ROUTE.NAME_MISMATCH, {
//               heading: heading,
//               key1: key1,
//               value1: value1,
//               key2: key2,
//               value2: value2,
//               isFromKYC: false,
//               ifscCode: ifscNum?.substring(0, 4)
//           })
//       } else if(typeof errorMessage === 'string') {
//           setTimeout(() => {
//               setDatastore(action.routeId, 'st', <BankSelectProps>{
//                   modalState: 'error',
//                   errorSubtitle: errorMessage

//               })
//           }, 0)
//       } else {
//           const failureJson =  JSON.parse(errorMessage)
//           if(failureJson?.failureType === "NAME_MISMATCH") {
//               const heading = failureJson?.nameMatchFailureDetails?.description
//               const key1 = failureJson?.nameMatchFailureDetails?.source?.description
//               const value1 = failureJson?.nameMatchFailureDetails?.source?.value
//               const key2 = failureJson?.nameMatchFailureDetails?.target?.description
//               const value2 = failureJson?.nameMatchFailureDetails?.target?.value
//               await navigate(ROUTE.NAME_MISMATCH, {
//                   heading: heading,
//                   key1: key1,
//                   value1: value1,
//                   key2: key2,
//                   value2: value2,
//                   isFromKYC: false,
//                   ifscCode: ifscNum?.substring(0, 4)
//               })
//           }
//       }
//   } else {
//       const currentStepId = _.get(
//           response,
//           'data.updatedApplicationObj.currentStepId',
//       )
//       if (currentStepId && currentStepId) {
//           await updateCurrentStepId(currentStepId)
//           const routeObj = await nextStepCredStepper()

//           setTimeout(() => {
//               setDatastore(action.routeId, 'st', <BankSelectProps>{
//                   modalState: 'success'
//               })
//           }, 0)

//           setTimeout(() => {
//               if (!hasNavigate) {
//                   navigateToBase(routeObj.routeId, routeObj.params)
//               }
//           }, 5000)

//       }

//       await setDatastore(action.routeId, 'continue', <ButtonProps>{
//           loading: false,
//       })
//   }
// }


export const fetchBankAccounts = async (payload: {
    applicationId: string;
}) => {

  let applicationId = payload.applicationId;
  let applicationIdStored = await AsyncStorage.getItem('application_id');

  if (applicationIdStored) {
    applicationId = applicationIdStored;
  }

  const response = await axios.get(endpoints.bav + applicationId);
  return response.data;
};

export const fetchBankAccountsFromApplication = async (payload: {
  applicationId: string;
}) => {
  let applicationId = payload.applicationId;
  let applicationIdStored = await AsyncStorage.getItem('application_id');

  if (applicationIdStored) {
    applicationId = applicationIdStored;
  }

  const response = await axios.get(endpoints.getBankAccountDetailsForLoanServicingApplication + applicationId);
  return response.data;
};


// on bank verify clicked


export const verifyBankAccount = async (payload: {
    applicationId: string;
    bankAccountNumber: string;
    bankIfscCode: string;
}) => {

  let applicationId = payload.applicationId;
  let applicationIdStored = await AsyncStorage.getItem('application_id')

  if (applicationIdStored) {
    applicationId = applicationIdStored;
  }


  // pick implementation from BavVerifyAction

  const response = await axios.post(endpoints.bavVerify, {
    applicationId,
    bankAccountDetails: {
      bankAccountNumber: payload.bankAccountNumber,
      bankIfscCode: payload.bankIfscCode,
    },
  });

  return response;

}


export const getStepper = async (payload: {
  applicationId: string;
}) => {

  let applicationId = payload.applicationId;
  let applicationIdStored = await AsyncStorage.getItem('application_id')

  if (applicationIdStored) {
    applicationId = applicationIdStored;
  }
  const response = await axios.post(endpoints.getStepper, {
    applicationId,
  });
  return response.data;
}
